/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Vedant Nagani",
  title: "Hi all, I'm Vedant",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 and Machine Learning Enthusiast 🤖 having an experience of building Web and Mobile applications, AI POCs and Machine Learning Pipelines."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1f9yIYDpDbHEoX3Z7pJQq6oOBZiMfDKkr/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Vedant13-ux",
  linkedin: "https://www.linkedin.com/in/vedant-nagani-a5607a1aa/",
  gmail: "vedantnagani@gmail.com",
  gitlab: "https://gitlab.gnome.org/vedantnagani",
  facebook: "https://www.facebook.com/vedant.nagani",
  medium: "https://medium.com/@vedantnagani",
  stackoverflow: "https://stackoverflow.com/users/16898423/vedant-nagani",
  // Instagram and Twitter are also supported in the links!
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡Develop AI based Web Applications and Mobile Applications"),
    emoji("⚡Develop AI POCs based on different datasets."),
    emoji(
      "⚡ Build Web Service / REST API's for everybody. "
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "flutter",
      fontAwesomeClassname: "fas fa-mobile-alt"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "machine learning",
      fontAwesomeClassname: "fas fa-robot"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },

    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "KJ Somaiya College of Engineering",
      logo: require("./assets/images/Logo-Somaiya-Vidyavihar.jpg"),
      subHeader: "Master of Science in Computer Science",
      duration: "Aug 2019 - May 2023",
      desc: "Pursuing B.Tech in Information Technology.",
      descBullets: [
        "Technical Member of the Coding Council - CodeCell.",
        "Developed a Internship and Event Management System for College integrated with Social Media Platform for Students, Alumni, Councils and Faculty."
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Machine Learning/Deep Learning", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Programming",
      progressPercentage: "80%"
    },
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },


  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [

    {
      role: "Machine Learning Intern",
      company: "EY (Ernst & Young)",
      companylogo: require("./assets/images/EY.png"),
      date: "Aug 2021 – Present",
      desc: "Working under the Assurance and Compliance Department.",
      descBullets: [
        "Working on building Predictive Models to avoid Frauds.",
        "Working on building AI Models to Detect Anomalies in Corporate Data."
      ]
    },
    {
      role: "Founder & CEO, Interncent",
      company: "Interncent",
      companylogo: require("./assets/images/interncent.png"),
      date: "Jul 2021 – Present",
      desc: "Educational Management System",
      descBullets: [
        "Internship offering platform personalized for college needs and a social media integrated with the platform for the students, faculties, councils, and alumni.",
      ]
    },
    {
      role: "Technical Team Member",
      company: "KJSCE CodeCell",
      companylogo: require("./assets/images/CodeCell Logo.png"),
      date: "Aug 2021 – Present",
      desc: "Part of the Technical Team.",
      descBullets: [
        "Conducting Hackathons, Technical Workshops and Events.",
      ]
    },
    {
      role: "Meachine Learning Engineer Intern",
      company: "ResoluteAi.in",
      companylogo: require("./assets/images/resoluteai.jpg"),
      date: "Jul 2021 – Aug 2021",
      desc: "Was a part of the Machine Learning team.",
      descBullets: [
        "Built AI POCs for Clients.",
        "Built Computer Vision and NLP based Solutions for clients.",
      ]
    },
    {
      role: "Full Stack Web Developer.",
      company: "KJ Somaiya College of Engineering",
      companylogo: require("./assets/images/Logo-Somaiya-Vidyavihar.jpg"),
      date: "Oct 2020 – Jan 2021",
      desc: "Made a Full Stack Web Application in MERN Stack.",
      descBullets: [
        "Internship offering platform personalized for college needs and a social media integrated with the platform for the students, faculties, councils, and alumni.",
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/interncent.png"),
      projectName: "Interncent Web Application",
      projectDesc: "Interncent is an internship offering platform for College. It is the place for the Faculties, Councils, or Alumni of the College to offer internships to the students. The platform is integrated with a social media platform of its own.",
      footerLink: [
        {
          name: "View Repository",
          url: "https://github.com/Vedant13-ux/College-Connect"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nlp.png"),
      projectName: "Question Generator",
      projectDesc: "This NLP-based Web Service which is useful for the teacher and the students as they can upload their notes in text/pdf format here and get the glossary, summary, questions based on them (for eg. MCQ, Fill Ups, True/False, Subjective).",
      footerLink: [
        {
          name: "View Repository",
          url: "https://github.com/Vedant13-ux/Question-Generator"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/scribbled.jpg"),
      projectName: "Scribbled Diaries",
      projectDesc: "It is a social media platform for writers, poets, and storytellers. It offers them the platform to showcase their skills. People can write book reviews here and chat among themselves on an exclusive messanger.",
      footerLink: [
        {
          name: "View Repository",
          url: "https://github.com/Vedant13-ux/Scribbled-Diaries"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "TechExpo Finalist",
      subtitle:
        "Ideated and built a prototype with my team.",
      image: require("./assets/images/techexpo.png"),
      footerLink: [
        {
          name: "Certificate",
          url: "https://drive.google.com/file/d/1OKxqzWcEXIVpBwgU8qTFj9E3AMWdR6km/view?usp=sharing"
        },

      ]
    },
    {
      title: "Deep Learning certification",
      subtitle:
        "Completed Machine Learning and Deep Learning Certification from Udemy.",
      image: require("./assets/images/udemy.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://www.udemy.com/certificate/UC-5dd59e6a-d367-46a5-b40c-e0fd73c814aa/"
        }
      ]
    },

    {
      title: "Python Specialization",
      subtitle: "Completed Python Certifcation from University of Michigan",
      image: require("./assets/images/michigan.jpg"),
      footerLink: [
        { name: "Certification", url: "https://coursera.org/share/15200fd61c4a398cb4f30e4be7495bc6" },

      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Advanced Python Workshop",
      subtitle: "I was one of the mentors at the Workshop hosted by CodeCell",
      slides_url: "https://drive.google.com/drive/folders/1DAIzwlnrMGgu-puNiD2dcHgEpPlNYH9v",
      event_url: "https://www.youtube.com/watch?v=IASJNV6ep9U&t=6004s"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  email_address: "vedantnagani@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
